import { IconSvg, IconSvgProps } from "./icon"

export default function YouTube(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeWidth={0} fill="currentColor">
      <path d="M22.299 6.056a2.832 2.832 0 0 0-1.993-2.006c-1.758-.474-8.806-.474-8.806-.474s-7.048 0-8.806.474A2.832 2.832 0 0 0 .7 6.056C.23 7.825.23 11.516.23 11.516s0 3.691.471 5.46a2.79 2.79 0 0 0 1.993 1.974c1.758.474 8.806.474 8.806.474s7.048 0 8.806-.474a2.79 2.79 0 0 0 1.993-1.974c.471-1.769.471-5.46.471-5.46s0-3.691-.471-5.46ZM9.195 14.867V8.165l5.89 3.351-5.89 3.351Z" />
    </IconSvg>
  )
}
